import { Component, Input } from '@angular/core';

export interface NewsletterData {
  description: string;
  email: string;
  subject: string;
  body: string;
  isPrimary: boolean;
  descriptionActionButton: string;
}

@Component({
  selector: 'fcp-newsletter',
  templateUrl: './newsletter.component.html',
  styleUrls: ['./newsletter.component.scss']
})
export class NewsletterComponent {
  @Input() public newsletter: NewsletterData;
}
